'use client';

import { FormTextField } from 'components/form';
import { generateShopMetadata } from 'components/meta';
import {
  Button,
  Center,
  Column,
  Container,
  Header,
  Row,
  Spacer,
  Typo,
} from 'components/ui-kit';
import { Form, Formik } from 'formik';
import { authService } from 'lib';
import { EMAIL_REGEXP } from 'lib/validators/validators';
import { Metadata, NextPage } from 'next/types';
import { useState } from 'react';
import * as yup from 'yup';

type TFormValues = {
  email: string;
};

const INITIAL_VALUES: TFormValues = { email: '' };
const validationSchema = yup.object().shape({
  email: yup
    .string()
    .email()
    .matches(EMAIL_REGEXP, 'Проверьте правильность ввода email')
    .required(),
});

export const ForgotPassword: NextPage = () => {
  const [isEmailSent, setIsEmailSend] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (values: TFormValues): Promise<void> => {
    setError('');

    try {
      await authService.restorePassword(values.email);
      setIsEmailSend(true);
    } catch {
      setIsEmailSend(false);
      setError('Email адрес не найден, проверьте и попробуйте еще раз!');
    }
  };

  return (
    <main>
      <Container>
        <Row>
          <Column span={{ s: 12 }}>
            <Spacer size={64} />
            <Header level={1} align="center">
              Восстановить пароль
            </Header>
            <Spacer size={64} />
          </Column>
          {!isEmailSent && (
            <Column span={{ s: 12, l: 6 }} offset={{ l: 3 }}>
              <Formik
                validationSchema={validationSchema}
                initialValues={INITIAL_VALUES}
                onSubmit={handleSubmit}
              >
                <Form placeholder="">
                  <FormTextField type="email" name="email" label="Email" />
                  {error && (
                    <>
                      <Spacer size={16} />
                      <Typo variant="m" color="alert">
                        {error}
                      </Typo>
                    </>
                  )}
                  <Spacer size={32} />
                  <Center>
                    <Button variant="primary" type="submit" size="l">
                      Продолжить
                    </Button>
                  </Center>
                  <Spacer size={112} />
                </Form>
              </Formik>
            </Column>
          )}

          {isEmailSent && (
            <Column span={{ s: 12, l: 6 }} offset={{ l: 3 }}>
              <Typo align="center" variant="xl">
                Письмо для восстановления пароля отправлено
              </Typo>
            </Column>
          )}
        </Row>
      </Container>
    </main>
  );
};
